import { useHirerAuth } from '@seek/hirer-auth-react';
import { useEffect } from 'react';

import { useRedirectURL } from 'src/App/context/Authentication/useRedirectURL';

import { LoadingBlock } from '../../pages/ad-budget-selection/components/Loading/Loading.tsx';

export const Authenticate: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { authenticated, loading, login } = useHirerAuth();

  const { origin, pathname, search } = useRedirectURL();

  useEffect(() => {
    if (!loading && !authenticated) {
      login({
        location: {
          origin,
          pathname,
          search,
        },
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, authenticated]);

  if (loading && !authenticated) {
    return <LoadingBlock />;
  }

  return <>{children}</>;
};
